/*
 * recently-viewed.js — 閲覧履歴（vanilla JS）
 * 旧 jQuery 版（jquery.products.min.js + jquery.tmpl + Shopify.Products）を置換。
 * - 記録: 商品ページで window.pbkCurrentProductHandle を localStorage に push
 * - 表示: #recently-viewed-products があれば Shopify AJAX API で各商品を取得して描画
 */
(function () {
  'use strict';
  if (window.__pbkRecentlyViewedInit) return;
  window.__pbkRecentlyViewedInit = true;

  var KEY = 'pbk_recently_viewed';
  var MAX = 12;

  function getHandles() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function record(handle) {
    if (!handle) return;
    var handles = getHandles().filter(function (h) { return h !== handle; });
    handles.unshift(handle);
    if (handles.length > MAX) handles = handles.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(handles)); } catch (e) {}
  }

  /* Shopify CDN 画像に width パラメータを付与 */
  function resize(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function cardHtml(product) {
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var src = resize(img, 400);
    return '' +
      '<li class="grid__item" itemscope itemtype="http://schema.org/Product">' +
        '<div class="card-wrapper product-card-wrapper">' +
          '<div id="product-' + escapeHtml(product.handle) + '" class="card card--standard card--media">' +
            '<div class="card__inner ratio" style="--ratio-percent: 100%;">' +
              '<div class="card__media">' +
                '<div class="media media--transparent media--hover-effect">' +
                  (src ? '<img class="motion-reduce" width="2280" height="2280" src="' + escapeHtml(src) + '" loading="lazy" alt="' + escapeHtml(product.title) + '" />' : '') +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div class="card__content">' +
              '<div class="card__information">' +
                '<h3 class="card__heading h5"><a href="' + escapeHtml(product.url) + '" class="full-unstyled-link">' + escapeHtml(product.title) + '</a></h3>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function show(container) {
    var limit = parseInt(container.getAttribute('data-limit'), 10) || 4;
    var current = window.pbkCurrentProductHandle || null;
    var handles = getHandles().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) {
      // 履歴が無ければセクションごと隠す（旧 jQuery 版でも空表示だった挙動の改善）
      var section = container.closest('.product-history');
      if (section) section.style.display = 'none';
      return;
    }
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(cardHtml).join('');
      if (html) {
        container.innerHTML = html;
      } else {
        var section = container.closest('.product-history');
        if (section) section.style.display = 'none';
      }
    });
  }

  /* quick-view(pbk-pdp-quickview.js) からの閲覧記録用に公開 */
  window.PBKRecentlyViewed = { record: record, getHandles: getHandles };

  function init() {
    if (window.pbkCurrentProductHandle) record(window.pbkCurrentProductHandle);
    var container = document.getElementById('recently-viewed-products');
    if (container) show(container);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
